"use client";

import React, { useState } from "react";
import { MoreHorizontalIcon } from "lucide-react";
import UpdateAccountForm from "./UpdateAccountForm";
import toast from "react-hot-toast";
import apiClient from "../../utils/apiClient";

export default function UserTable({ userId, userSubAccounts }) {
  const [openRowIndex, setOpenRowIndex] = useState(null);
  const [editBoxPosition, setEditBoxPosition] = useState({ top: 0 });

  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    index: 0,
    accountData: userSubAccounts[0],
  });

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = (index, data) => {
    setShowModal(true);
    setOpenRowIndex(null);
    setFormData({
      index: index,
      accountData: data,
    });
  };

  const toggleEdit = (e, index) => {
    if (openRowIndex === index) {
      setOpenRowIndex(null);
    } else {
      setOpenRowIndex(index);

      setOpenRowIndex(index); // Open the edit box for the clicked row
      // Calculate the position relative to the clicked row
      const row = e.target.closest("tr");
      const rowRect = row.getBoundingClientRect();
      setEditBoxPosition({
        top: rowRect.bottom - 8,
      });
    }
  };

  // To Stop the Server
  const handleUnDeployServer = async (index, accountId) => {
    setOpenRowIndex(null);
    const formRequestBodyUndeploy = {
      accountId: accountId,
      newState: "Undeployed",
      connection: "Disconnected",
    };

    

    // console.log("Response Data For Stopping Server", stopServerData);

    // console.log("Stopping Server acc with index", index);
    // console.log("account wit id Undeployed, server Stopped!!",accountId);
    setOpenRowIndex(null);
  };

  // To Restart The Server

  const handleReDeployServer = async (index, accountId) => {
    setOpenRowIndex(null);
    const formRequestBodyRedeploy = {
      accountId: accountId,
      newState: "Deployed",
      connection: "Connected",
    };

    const response = await apiClient.post("/api/start-account-server", formRequestBodyRedeploy);
    const startServerData = response.data;
    // console.log("1st Response Data For Starting Server", startServerData);

    if (startServerData.status === 200) {
      toast.success(`Server Deployed SuccessFully!!`, {
        style: {
          minWidth: "250px",
        },
        success: {
          duration: 10000,
          icon: "🔥",
        },
      });

      return;
    }

    if (startServerData.status === 404) {
      toast.loading(`Trying to connect to server it  will take some time.`, {
        style: {
          minWidth: "250px",
        },
        duration: 10000,
      });
      toast.loading(`Waiting For Server Connection`, {
        style: {
          minWidth: "250px",
        },
        duration: 16000,
      });
      // Waiting for 3 mins for Server Connection

      await new Promise((resolve) => setTimeout(resolve, 180000));

      // console.log("3 min Completed 1st Time !!!");
      const responseTwo = await apiClient.post("/api/start-account-server", formRequestBodyRedeploy);
      const startServerDataTwo = responseTwo.data;
      // console.log(
      //   "Response Data For Starting Server 2nd Time ",
      //   startServerResponseTwo
      // );

      if (startServerDataTwo.status === 200) {
        toast.success(`Server Deployed SuccessFully !!`, {
          style: {
            minWidth: "250px",
          },
          success: {
            duration: 10000,
            icon: "🔥",
          },
        });

        return;
      } else {
        toast.loading(`Trying to connect to server it  will take some time.`, {
          style: {
            minWidth: "250px",
          },
          duration: 10000,
        });
        // Waiting for 3 mins for Server Connection

        await new Promise((resolve) => setTimeout(resolve, 180000));
        // console.log("3 min Completed 2nd Time !!!");

        const responseThree = await apiClient.post("/api/start-account-server", formRequestBodyRedeploy);
        const startServerDataThree = responseThree.data;

        if (startServerDataThree.status === 200) {
          toast.success(`Server Deployed Successfully !!`, {
            style: {
              minWidth: "250px",
            },
            success: {
              duration: 10000,
              icon: "🔥",
            },
          });

          return;
        } else {
          toast.error(`Server Restart Failed!!, please Try Again.`, {
            style: {
              minWidth: "250px",
            },
            duration: 10000,
          });
        }
      }
    }

    // console.log("Starting Server acc with index", index);
    // console.log("Account with id Redeployed, server Started!!",accountId);
    setOpenRowIndex(null);
  };

  const handleDelete = async (index, accountId) => {
    const formRequestBodyDelete = {
      accountId: accountId,
    };

    const response = await apiClient.post("/api/delete-sub-account", formRequestBodyDelete);
    const responseData = response.data;

    if (responseData.status === 200) {
      toast.success(`Account Deleted !!`, {
        style: {
          minWidth: "250px",
        },
        duration: 6000,
      });
    } else if (responseData.status === 200) {
      toast.error(`Account Deletion Failed !!`, {
        style: {
          minWidth: "250px",
        },
        duration: 6000,
      });
    }

    // console.log("Response Data After delete Account", responseData);

    // console.log("deleteing acc with index", index);
    // console.log("deleteing acc with accountId", accountId);

    setOpenRowIndex(null);
  };

  const handleView = () => {
    setOpenRowIndex(null);
  };
  return (
    <div className="z-0 relative w-full h-full mt-20  overflow-auto sm:overflow-hidden ">
      <div className="  w-full sm:max-h-[690px]   custom-scroll  shadow-md ">
        <table className="  w-full  text-sm  ">
          <thead className="text-sm text-left ">
            <tr className="   bg-[#0f0f0f] text-white border-b border-t  border-gray-800">
              <th className="px-4 py-6 ">Account Id</th>

              <th className="px-4 py-6">Account Name</th>
              <th className="px-4 py-6 ">State</th>

              <th className="px-4 py-6">Balance</th>

              <th className="px-4 py-6">Login</th>

              <th className="px-4 py-6">Trade Allowed</th>

              <th className="px-4 py-6">Connection Status</th>

              <th className="px-4 py-6">Copy Factory Role</th>

              <th className="px-4 py-6">
                <span className="sr-only">Edit</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {userSubAccounts?.map((data, index) => (
              <tr
                key={data?.login}
                className=" bg-black z-0 border-b border-gray-800 font-medium text-white hover:bg-black/90"
              >
                <td className="px-4 py-4">{data.account_id}</td>

                <td className={`px-4 py-4  `}>
                  <span
                    className={`${
                      data.state.toLowerCase() === "deployed"
                        ? "bg-emerald-100 text-emerald-600"
                        : "bg-red-200 text-red-600"
                    } py-1 px-2 rounded-md uppercase`}
                  >
                    {data.state}
                  </span>
                </td>

                <td className="px-4 py-4">{data.balance}</td>

                <td className="px-4 py-4">{data.account_name}</td>
                <td className="px-4 py-4">{data.login}</td>

                <td className="px-4 py-4">
                  {data.trade_allowed ? "Yes" : "No"}
                </td>

                <td className="  px-4 py-4">
                  <span
                    className={`${
                      data.connection_status.toLowerCase() === "connected"
                        ? "bg-emerald-100 text-emerald-600"
                        : data.connection_status.toLowerCase() === "connecting"
                        ? "bg-amber-200 text-amber-600"
                        : "bg-red-200 text-red-600"
                    } py-1 px-2 rounded-md uppercase`}
                  >
                    {data.connection_status.toLowerCase() === "connecting"
                      ? "Connecting..."
                      : data.connection_status}
                  </span>
                </td>

                <td className="px-4 py-4">
                  <span
                    className={`${
                      data.copy_factory_roles[0].toLowerCase() === "subscriber"
                        ? "bg-blue-200 text-blue-600"
                        : "bg-purple-200 text-purple-600"
                    } py-1 px-2 rounded-md`}
                  >
                    {data.copy_factory_roles.join(", ")}
                  </span>
                </td>

                <td className="relative px-2">
                  <div
                    onClick={(e) => toggleEdit(e, index)}
                    className="flex items-center justify-center cursor-pointer bg-white rounded-md hover:bg-gray-600 hover:text-white h-8 w-8"
                  >
                    <MoreHorizontalIcon className=" h-6 w-6 text-black" />
                  </div>
                  {openRowIndex === index && (
                    <div
                      className={`p-2   top-[20px] right-12 absolute  z-10 bg-gray-200  w-[120px]  rounded-md`}
                    >
                      <button
                        onClick={handleView}
                        className="text-xs w-full text-left font-semibold text-gray-900 hover:bg-gray-600 hover:text-white rounded-md cursor-pointer py-1 px-1.5"
                      >
                        View
                      </button>
                      <button
                        onClick={() => handleShowModal(index, data)}
                        className="text-xs w-full text-left font-semibold text-gray-900 hover:bg-gray-600 hover:text-white rounded-md cursor-pointer py-1 px-1.5"
                      >
                        Update Account
                      </button>
                      <button
                        onClick={() =>
                          handleUnDeployServer(index, data.account_id)
                        }
                        className="text-xs w-full text-left font-semibold text-gray-900 hover:bg-gray-600 hover:text-white rounded-md cursor-pointer py-1 px-1.5"
                      >
                        Stop Server
                      </button>
                      <button
                        onClick={() =>
                          handleReDeployServer(index, data.account_id)
                        }
                        className="text-xs w-full text-left font-semibold text-gray-900 hover:bg-gray-600 hover:text-white rounded-md cursor-pointer py-1 px-1.5"
                      >
                        Restart Server
                      </button>
                      <button
                        onClick={() => handleDelete(index, data.account_id)}
                        className=" w-full text-left text-xs font-semibold text-gray-900 hover:bg-gray-600 hover:text-white rounded-md cursor-pointer py-1 px-1.5"
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </td>

                <td className="flex absolute md:top-2 md:right-4">
                  {showModal && (
                    <UpdateAccountForm
                      userId={userId}
                      index={formData?.index}
                      accountData={formData?.accountData}
                      showModal={showModal}
                      handleCloseModal={handleCloseModal}
                      handleReDeployServer={handleReDeployServer}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
